import type { JSX } from 'react';

import { ButtonLink, ExternalButtonLink } from '@/components/ui/Button';
import { ArrowRightIcon, LinkedInIcon, LocationIcon } from '@/components/ui/icons';
import { ProofPointList } from '@/components/domain/ProofPointList';
import { profile, proofPoints } from '@/content/profile';

export function Hero(): JSX.Element {
  const linkedIn = profile.links.find((link) => link.id === 'linkedin');

  return (
    <section aria-labelledby="hero-heading" className="relative overflow-hidden">
      <div aria-hidden="true" className="grid-backdrop absolute inset-0 -z-10 opacity-70" />

      <div className="shell-container py-20 sm:py-24 lg:py-32">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-accent">{profile.role}</p>

        <h1 id="hero-heading" className="mt-5 max-w-4xl text-4xl sm:text-5xl lg:text-6xl">
          {profile.headline}
        </h1>

        <p className="mt-6 max-w-2xl text-lg text-muted">{profile.summary}</p>

        <p className="mt-6 flex items-center gap-2 text-sm text-muted">
          <LocationIcon width={16} height={16} />
          {profile.location}
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <ButtonLink to="/case-studies" size="lg">
            View case studies
            <ArrowRightIcon width={18} height={18} />
          </ButtonLink>
          <ButtonLink to="/contact" size="lg" variant="secondary">
            Contact me
          </ButtonLink>
          <ButtonLink to="/cv" size="lg" variant="ghost">
            View CV
          </ButtonLink>
          {linkedIn ? (
            <ExternalButtonLink href={linkedIn.href} size="lg" variant="ghost">
              <LinkedInIcon width={18} height={18} />
              LinkedIn
            </ExternalButtonLink>
          ) : null}
        </div>

        <ProofPointList items={proofPoints} className="mt-16" />
      </div>
    </section>
  );
}
